import { Colors, Flex, Typography, useScreenSize } from '@banhala/ui-kit';
import { useAtom, useAtomValue } from 'jotai';
import { ScrollView } from 'react-native';
import { useMyPersonalizationSizeAtoms } from '../../state';
import { useCallback, useRef } from 'react';

export const ProductCategoryTabBar = () => {
  const { selectedProductCategoryGroupAtom, selectedProductCategoryAtom } =
    useMyPersonalizationSizeAtoms();
  const selectedGroup = useAtomValue(selectedProductCategoryGroupAtom);
  const [selectedProductCategory, setSelectedProductCategory] = useAtom(
    selectedProductCategoryAtom,
  );

  const { width: containerWidth } = useScreenSize();
  const scrollRef = useRef<ScrollView>(null);
  /**각 tabItem의 좌표값을 보관하고  스크롤 시 중앙에 위치하도록 스크롤 */
  const itemLayoutsRef = useRef<Map<number, { x: number; width: number }>>(
    new Map(),
  );

  const scrollToCenter = useCallback(
    (sno: number) => {
      const layout = itemLayoutsRef.current.get(sno);
      if (!layout) return;
      const targetX = layout.x + layout.width / 2 - containerWidth / 2;
      scrollRef.current?.scrollTo({ x: Math.max(0, targetX), animated: true });
    },
    [containerWidth],
  );

  const handleSelectProductCategory = useCallback(
    (productCategorySno: number) => {
      const found = selectedGroup.product_categories.find(
        category => category.product_category_sno === productCategorySno,
      );
      if (!found) {
        console.error('Selected product category not found');
        return;
      }
      setSelectedProductCategory(found);
      scrollToCenter(productCategorySno);
    },
    [selectedGroup, setSelectedProductCategory, scrollToCenter],
  );

  return (
    <Flex
      backgroundColor="bg_secondary"
      borderColor="border_tertiary"
      borderBottomWidth={1}
    >
      <ScrollView
        ref={scrollRef}
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={{ paddingHorizontal: 8, paddingVertical: 4 }}
      >
        {selectedGroup.product_categories.map(category => {
          const isSelected =
            category.product_category_sno ===
            selectedProductCategory.product_category_sno;
          return (
            <Flex
              key={category.product_category_sno}
              onLayout={e => {
                const { x, width } = e.nativeEvent.layout;
                itemLayoutsRef.current.set(category.product_category_sno, {
                  x,
                  width,
                });
              }}
              borderRadius={4}
              padding={{ horizontal: 8, vertical: 8 }}
              height={32}
              alignItems="center"
              justifyContent="center"
              onPress={() =>
                handleSelectProductCategory(category.product_category_sno)
              }
            >
              <Typography
                type={isSelected ? 'subtitle3' : 'body3'}
                rawColor={
                  isSelected ? Colors.content_primary : Colors.content_secondary
                }
              >
                {category.product_category_name}
              </Typography>
            </Flex>
          );
        })}
      </ScrollView>
    </Flex>
  );
};
